import { format, parse, isValid } from 'date-fns';
import type { DateRange } from 'react-day-picker';

export const DATE_RANGE_FILTER_SEPARATOR = '|';

export function encodeDateRangeFilter(range: DateRange | undefined): string {
  if (!range?.from) return '';
  const start = format(range.from, 'yyyy-MM-dd');
  const end = format(range.to ?? range.from, 'yyyy-MM-dd');
  return `${start}${DATE_RANGE_FILTER_SEPARATOR}${end}`;
}

export function decodeDateRangeFilter(value: string): DateRange | undefined {
  const [startStr, endStr] = value.split(DATE_RANGE_FILTER_SEPARATOR);
  if (!startStr) return undefined;
  const from = parse(startStr, 'yyyy-MM-dd', new Date());
  if (!isValid(from)) return undefined;
  const toRaw = endStr || startStr;
  const to = parse(toRaw, 'yyyy-MM-dd', new Date());
  if (!isValid(to)) return { from };
  return { from, to };
}

export function formatDateRangeFilterLabel(value: string): string {
  const range = decodeDateRangeFilter(value);
  if (!range?.from) return value;
  const startLabel = format(range.from, 'MMM d, yyyy');
  const end = range.to ?? range.from;
  if (format(range.from, 'yyyy-MM-dd') === format(end, 'yyyy-MM-dd')) {
    return startLabel;
  }
  return `${startLabel} – ${format(end, 'MMM d, yyyy')}`;
}

export function parseFilterableDate(cellValue: unknown): Date | null {
  if (cellValue === null || cellValue === undefined || cellValue === '' || cellValue === '-') {
    return null;
  }
  const raw = String(cellValue);
  const iso = parse(raw, 'yyyy-MM-dd', new Date());
  if (isValid(iso)) return iso;
  const withTime = parse(raw, 'MMM d, yyyy, h:mm a', new Date());
  if (isValid(withTime)) return withTime;
  const dateOnly = parse(raw, 'MMM d, yyyy', new Date());
  if (isValid(dateOnly)) return dateOnly;
  const fallback = new Date(raw);
  return isValid(fallback) ? fallback : null;
}
